var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card)?_c('div',{staticClass:"card-menu",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('NcActions',[_c('CardMenuEntries',{attrs:{"card":_vm.card}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }